import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import Layout from "../../component/Layout";
import api from "../../axios";
import { useNavigate } from "react-router-dom";
export default function Users() {
  const [users, setUsers] = useState([]);
  const [licenses, setLicenses] = useState([]);
  const [devices, setDevices] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    const isAdmin = sessionStorage.getItem('isAdmin') === 'true';
    if (!isAdmin) {
      navigate('/dashboard');
      return;
    }
    const fetchData = async () => {
      try {
        const [userRes, licenseRes, deviceRes] = await Promise.all([
          api.get("/api/users"),
          api.get("/api/license"),
          api.get("/api/device")
        ]);
        setUsers(userRes.data);
        setLicenses(licenseRes.data);
        setDevices(deviceRes.data);
      } catch (error) {
        console.error("Veri alınırken hata:", error);
      }
    };

    fetchData();
  }, []);

  const getUserLicenses = (userId) => {
    return licenses.filter(l => l.userId === userId);
  };

  const getLicenseDevices = (licenseId) => {
    return devices.filter(d => d.licenseId === licenseId);
  };

  return (
    <>
      <Helmet>
        <title>Kullanıcılar</title>
      </Helmet>
      <Layout pageTitle="Kullanıcılar ve Lisanslar">
        <div className="p-4 space-y-6">
          {users.map((user) => (
            <div key={user.userID} className="bg-white rounded shadow p-4">
              <h3 className="text-lg font-semibold text-indigo-700">{user.userName} - {user.fullName}</h3>
              <p className="text-sm text-gray-600">{user.email}</p>

              <div className="mt-4 pl-4 border-l border-indigo-200 space-y-2">
                {getUserLicenses(user.userID).map((license) => (
                  <div key={license.id} className="bg-gray-100 p-3 rounded">
                    <div className="text-sm font-medium text-gray-700">
                      {license.softwareName} ({license.packageName || "Paketsiz"})
                    </div>

                    <ul className="mt-2 ml-4 list-disc text-sm text-gray-600 space-y-1">
                      {getLicenseDevices(license.id).map((device) => (
                        <li key={device.id}>
                          {device.deviceName} — {device.os} ({device.iP_Global})
                        </li>
                      ))}
                      {getLicenseDevices(license.id).length === 0 && (
                        <li className="text-gray-400 italic">Cihaz kaydı yok</li>
                      )}
                    </ul>
                  </div>
                ))}
                {getUserLicenses(user.userID).length === 0 && (
                  <div className="text-sm italic text-gray-400">Lisans yok</div>
                )}
              </div>
            </div>
          ))}
        </div>
      </Layout>
    </>
  );
}
